module.exports = __webpack_public_path__ + "static/1-29ae1d574b921f0ba7a9a265e9327b0e.png";